// extracted by mini-css-extract-plugin
export default {"button":"styles_button__VV2ls","playIcon":"styles_playIcon__yMP+H","title":"styles_title__00d2v"};